/**
 * All durations are set in frames (based on a 60fps motion)
 * and then converted in ms
 */
export const frameToMs = (frame) => frame * (1000 / 60);
export const pauseMotions = (motions) => {
    motions.forEach((m) => m?.pause());
};
export const durations = {
    /** First Panel -> Panel */
    FIRST_PANEL_TRANSLATE_IN: frameToMs(42),
    FIRST_PANEL_TRANSLATE_OUT: frameToMs(15),
    FIRST_PANEL_OPACITY_IN: frameToMs(20),
    FIRST_PANEL_OPACITY_OUT: frameToMs(8),
    /** First Panel -> Lists */
    FIRST_PANEL_LIST_STAGGER_IN: frameToMs(5),
    /** First Panel -> Items */
    FIRST_PANEL_ITEMS_STAGGER: frameToMs(1),
    FIRST_PANEL_ITEMS_TRANSLATE_IN_DELAY: frameToMs(10),
    FIRST_PANEL_ITEMS_OPACITY_IN_DELAY: frameToMs(20),
    FIRST_PANEL_ITEMS_TRANSLATE: frameToMs(40),
    FIRST_PANEL_ITEMS_OPACITY: frameToMs(20),
    /** Second panel -> Panel (desktop, snappier than before) */
    SECOND_PANEL_TRANSLATE_IN: frameToMs(28),
    SECOND_PANEL_TRANSLATE_OUT: frameToMs(12),
    SECOND_PANEL_OPACITY_OUT: frameToMs(6),
    /** Second Panel -> Items (desktop) */
    SECOND_PANEL_ITEMS_STAGGER: frameToMs(1),
    SECOND_PANEL_ITEMS_OPACITY_IN_DELAY: frameToMs(10),
    SECOND_PANEL_ITEMS_TRANSLATE: frameToMs(26),
    SECOND_PANEL_ITEMS_OPACITY: frameToMs(8),
    /** Second panel (mobile) -> keeps the previous, slower timings */
    SECOND_PANEL_MOBILE_OPACITY_IN: frameToMs(20),
    SECOND_PANEL_MOBILE_ITEMS_STAGGER: frameToMs(1),
    SECOND_PANEL_MOBILE_ITEMS_TRANSLATE_IN_DELAY: frameToMs(10),
    SECOND_PANEL_MOBILE_ITEMS_OPACITY_IN_DELAY: frameToMs(20),
    SECOND_PANEL_MOBILE_ITEMS_TRANSLATE: frameToMs(40),
    SECOND_PANEL_MOBILE_ITEMS_OPACITY: frameToMs(20)
};
